import { create } from 'zustand';
import { produce, Draft } from 'immer';

import { createSelectors } from '../create-selectors';

import { EntradasSlice, createEntradasSlice } from './entradas.slice';
import { FuncionSlice, createFuncionSlice } from './funcion.slice';
import { CompraSlice, createCompraSlice } from './compra.slice';
import { CompradorSlice, createCompradorSlice } from './comprador.slice';
import { Funcion } from '@/types';
import { Gateway } from '@/schemas/checkout.schema';

export interface ClearAllOptions {
    tabs?: EventoStore['tabs']['state'];
    funcion?: Funcion | null;
    entradas?: EventoStore['entradas']['state'];
}

export interface EventoStore {
    funcion: FuncionSlice;
    entradas: EntradasSlice;
    compra: CompraSlice;
    comprador: CompradorSlice;
    gateway: {
        state: Gateway | null;
        set: (gateway: Gateway | null) => void;
    };
    reserva: {
        state: string | null;
        set: (reservaId: string | null) => void;
    }
    tabs: {
        state: string;
        set: (tabId: string) => void;
    },
    isLoading: {
        state: boolean;
        set: (isLoading: boolean) => void;
    },
    error: {
        state: string | null;
        set: (error: string | null) => void;
    },
    clearAll: (options?: ClearAllOptions) => void;
}

export const useEventoStore = create<EventoStore>()((set) => ({
    funcion: createFuncionSlice(set),
    entradas: createEntradasSlice(set),
    compra: createCompraSlice(set),
    comprador: createCompradorSlice(set),
    gateway: {
        state: null,
        set: (gateway) => set(produce((state: Draft<EventoStore>) => { state.gateway.state = gateway; })),
    },
    tabs: {
        state: 'detalles',
        set: (tabId) => set(produce((state: Draft<EventoStore>) => { state.tabs.state = tabId; })),
    },
    reserva: {
        state: null,
        set: (reservaId) => set(produce((state: Draft<EventoStore>) => { state.reserva.state = reservaId; })),
    },
    isLoading: {
        state: false,
        set: (isLoading) => set(produce((state: Draft<EventoStore>) => { state.isLoading.state = isLoading; })),
    },
    error: {
        state: null,
        set: (error) => set(produce((state: Draft<EventoStore>) => { state.error.state = error; })),
    },
    clearAll: (options?: ClearAllOptions) => set(produce((state: Draft<EventoStore>) => {
        state.funcion.state = options?.funcion !== undefined ? options.funcion : null;
        state.entradas.state = options?.entradas !== undefined ? options.entradas : [];
        state.compra.state = { status: null, message: '', compraId: null };
        state.comprador.state = null;
        state.gateway.state = null;
        state.reserva.state = null;
        state.tabs.state = options?.tabs ?? 'detalles';
        state.isLoading.state = false;
        state.error.state = null;
    })),
}));

export const useEvento = createSelectors(useEventoStore);